<template>
  <div class="delivery-info">
    <div class="shipto-title">
      Delivery
    </div>
    <div class="h5-shipto">
      <div class="row-1">
        <Icon
          class="left-icon"
          name="global-delivery-l"
        />
        <div class="right">
          <span class="h5-shipto-left-title">Shipping to:</span>
          <img
            :src="ship.country.countryUrl"
            alt=""
            class="ship-country-img"
          >
          <span class="ship-main-title">
            {{ ship.country.countryName }}
          </span>
          <span
            @click="handleShipChange"
            class="change-address"
          >Change</span>
        </div>
      </div>
      <div class="row-2">
        Estimated Delivery Time:
        <span class="count">
          {{ minDeliveryTime }}
          -
          {{ maxDeliveryTime }}
        </span>
        days.
      </div>
    </div>
    <div class="h5-supplier">
      <div class="h5-supplier-left">
        <Icon
          class="left-icon"
          name="business-icon"
        />
        <span class="h5-supplier-left-2">Fulfillment Supplier:</span>
        <img
          class="h5-supplier-left-3"
          src="@/assets/images/bd-logo.svg"
          width="86px"
          alt=""
        >
      </div>
      <div class="h5-supplier-right">
        Professional international fulfillment services
      </div>
    </div>
    <div
      class="h5-supplier"
      style="margin-top: 8px;"
    >
      <div class="h5-supplier-left">
        <Icon
          class="left-icon"
          name="a-leixingiconleibieCCYtubiaomoney-credit-cardfangshioff"
        />
        <span class="h5-supplier-left-2">Payment Methods:</span>
        <span class="support-with">
          with
          <img
            src="@/assets/illus/illus-paypal.svg"
            alt=""
          >
          or
          <span class="bank">&nbsp;Bank Transfer</span>
        </span>
      </div>
    </div>

    <H5Dialog
      v-model="showH5ShipTo"
      height="98%"
      :init-styles="{ background: 'white' }"
    >
      <H5ShipTo
        @save="handleUpdateCountry"
        :handle-close="closeH5ShipTo"
      />
    </H5Dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Icon from '@/components/Icon/Icon.vue'
import H5Dialog from '@/components/H5/H5Dialog/index.vue'
import H5ShipTo from '@/components/H5/H5ShipTo/index.vue'
import { useShipStore } from '@/pinia/ship'

const props = defineProps({
  minDeliveryTime: {
    type: Number,
    default: 0
  },
  maxDeliveryTime: {
    type: Number,
    default: 0
  },
  event: {
    type: Boolean,
    default: true
  }
})

const emits = defineEmits('reCaclShipFee')

const ship = useShipStore()

const showH5ShipTo = ref(false)
const handleShipChange = () => {
  if (props.event) {
    showH5ShipTo.value = true
  }
}

const handleUpdateCountry = () => {
  showH5ShipTo.value = false
  emits('reCaclShipFee')
}

const closeH5ShipTo = () => {
  showH5ShipTo.value = false
}

</script>

<style lang='less' scoped>
.delivery-info {
  padding-bottom: 4px;
  .shipto-title {
    color: #232323;
    font-size: 12px;
    font-family: mon-700;
    line-height: 16px;
    margin-top: 18px;
  }

  .left-icon {
    font-size: 20px;
  }

  .h5-shipto {
    margin-top: 12px;

    .row-1 {
      display: flex;
      align-items: center;
      gap: 8px;

      .right {
        display: flex;
        align-items: center;
        .h5-shipto-left-title {
          font-size: 12px;
          font-family: mon-600;
          color: #232323;
        }
        .ship-country-img {
          width: 14px;
          object-fit: contain;
          margin-left: 8px;
        }

        .ship-main-title {
          font-size: 12px;
          font-family: mon-600;
          color: #232323;
          margin-left: 2px;
        }
        .change-address {
          margin-left: 6px;
          color: #232323;
          font-size: 11px;
          font-family: mon-500;
          text-decoration: underline;
        }
      }
    }
    .row-2 {
      margin-top: 4px;
      margin-left: 28px;
      color: #232323;
      font-size: 11px;
      font-family: mon-500;
      .count {
        font-family: mon-700;
        color:#529426;
      }
    }
  }

  .h5-supplier {
    margin-top: 10px;
    .h5-supplier-left {
      display: flex;
      align-items: center;

      .h5-supplier-left-2 {
        font-family: mon-600;
        color: #232323;
        font-size: 12px;
        margin-left: 8px;
      }
      .support-with {
        display: flex;
        align-items: center;
        margin-left: 4px;
        color: #232323;
        font-size: 12px;
        font-family: mon-500;
        .bank {
          font-family: mon-700;
        }
      }
      .h5-supplier-left-3 {
        margin-left: 8px;
      }
      .h5-supplier-left-2-img {
        margin-left: 8px;
        width: 191px;
      }
    }

    .h5-supplier-right {
      padding: 0px 0px 0px 28px;
      position: relative;
      bottom: 2px;
      font-size: 10px;
      line-height: 14px;
      color: #B03718;
      font-family: mon-500;
      margin-top: 4px;
      .h5-supplier-right-1 {
        width: 41px;
        height: 14px;
        background-color: #FFE2D3;
        border-radius: 2px;
        font-size: 8px;
        font-family: mon-500;
        color: #863B00;
        line-height: 14px;
        text-align: center;
      }
    }
  }
}
</style>
